<template>
  <div class="point-supplement-template">
    <!-- 主訊息區塊 -->
    <div class="point-supplement-template__main-message">
      <div class="point-supplement-template__description">
        {{ $t('OrderFood.PointSupplementTemplate.MainMessage1', { pointTypeText: pointTypeText, supplementPointTypeText: supplementPointTypeText }) }}
        <span class="point-supplement-template__supplement-amount">{{ supplementPoints }}</span>{{ $t('OrderFood.PointSupplementTemplate.MainMessage2', { pointTypeText: pointTypeText }) }}
      </div>
      <div class="point-supplement-template__question">
        {{ $t('OrderFood.PointSupplementTemplate.ConfirmToSupplement') }}
      </div>
    </div>

    <!-- 點數計算區塊 -->
    <div class="point-supplement-template__calculation">
      <h3 class="point-supplement-template__calculation-title">
        {{ $t('OrderFood.PointSupplementTemplate.CalculationTitle') }}
      </h3>
      <div class="point-supplement-template__calculation-details">
        <div class="point-supplement-template__calculation-row">
          <span>{{ $t('OrderFood.PointSupplementTemplate.Have') }}{{ pointTypeText }}：{{ originalPoints }} {{ $t('OrderFood.PointSupplementTemplate.Points') }}</span>
          <span class="point-supplement-template__supplement-amount">
            <span class="point-supplement-template__supplement-amount-sign">+</span>
            {{ supplementPoints }}{{ supplementPointTypeText }}</span>
          <span>= {{ finalPoints }} {{ $t('OrderFood.PointSupplementTemplate.Points') }}</span>
        </div>
        <div class="point-supplement-template__calculation-row">
          <span>{{ $t('OrderFood.PointSupplementTemplate.Have') }}{{ supplementPointTypeText }}：{{ supplementOriginalPoints }} {{ $t('OrderFood.PointSupplementTemplate.Points') }}</span>
          <span class="point-supplement-template__supplement-amount">
            <span class="point-supplement-template__supplement-amount-sign">-</span>
            {{ supplementPoints }}{{ supplementPointTypeText }}</span>
          <span>= {{ supplementFinalPoints }} {{ $t('OrderFood.PointSupplementTemplate.Points') }}</span>
        </div>
      </div>
    </div>

    <!-- 備註說明區塊 -->
    <div class="point-supplement-template__footnotes">
      <p class="point-supplement-template__footnote point-supplement-template__footnote--exchange-rate">
        <span class="point-supplement-template__footnote-sign">*</span>
        <span>{{ $t('OrderFood.PointSupplementTemplate.PointsRate') }}</span>
      </p>
      <p class="point-supplement-template__footnote point-supplement-template__footnote--refund-policy">
        <span class="point-supplement-template__footnote-sign">*</span>
        <span>{{ $t('OrderFood.PointSupplementTemplate.RefundPolicy') }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PointSupplementTemplate',
  props: {
    // 主要點數類型（不足的）
    pointType: {
      type: Number,
      required: true,
      validator: value => [1, 2].includes(value) // 1: 一般點數, 2: 現金點數
    },
    // 原始點數（主要點數類型的當前點數）
    originalPoints: {
      type: Number,
      required: true
    },
    // 補足點數（需要補足的點數）
    supplementPoints: {
      type: Number,
      required: true
    },
    // 補足點數類型的原始點數
    supplementOriginalPoints: {
      type: Number,
      required: true
    }
  },
  computed: {
    // 主要點數類型文字
    pointTypeText () {
      return this.pointType === 1 ? this.$t('OrderFood.NormalPoints') : this.$t('OrderFood.CashPoints')
    },
    // 補足點數類型文字
    supplementPointTypeText () {
      return this.pointType === 1 ? this.$t('OrderFood.CashPoints') : this.$t('OrderFood.NormalPoints')
    },
    // 補足後的主要點數
    finalPoints () {
      return this.originalPoints + this.supplementPoints
    },
    // 補足後的補足點數類型點數
    supplementFinalPoints () {
      return this.supplementOriginalPoints - this.supplementPoints
    }
  }
}
</script>

<style lang="scss" scoped>
.point-supplement-template {
  &__main-message {
    margin-bottom: 30px;
  }

  &__description {
    font-size:  map-get($fontSize, medium);
  }

  &__supplement-amount {
    color: $infoColor;
    font-weight: 600;
    margin: 0 4px 0 2px;
  }

  &__supplement-amount-sign {
    display: inline-block;
    width: 10px;
    text-align: center;
    margin: 0 2px 0 2px;
  }

  &__question {
    font-size:  map-get($fontSize, medium);
  }

  &__calculation {
    font-size:  map-get($fontSize, medium);
    margin-bottom: 30px;
  }

  &__calculation-title {
    font-weight: bold;
    color: $black;
    margin: 0 0 12px 0;
  }

  &__calculation-row {
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    color: #333;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__footnote {
    font-size: map-get($fontSize, small);
    color: #ff4d4f;
    margin: 4px 0;
    line-height: 1.4;

    &--exchange-rate {
      margin-bottom: 4px;
    }

    &--refund-policy {
      margin: 0;
    }
  }

  &__footnote-sign {
    margin-right: 4px;
  }
}
</style>
